import { Trans } from '@lingui/react/macro';

import { useNavigate } from '@/components/Link/Link';
import Button from '@/design_system/Button';
import { Variant } from '@/design_system/Button/Button';
import IconShipmentNew from '@/icons/ShipmentNew.svg';
import { useArticleContext } from '@/routes/Requests/contexts/ArticleContext';

export const CreateShipmentButton = ({ variant = 'primary' }: { variant?: Variant }) => {
  const navigate = useNavigate();
  const { article } = useArticleContext();

  return (
    <Button
      variant={variant}
      size="medium"
      onPress={() =>
        navigate('/shipments/new', {
          state: { requestId: article.requestId, articleId: article.id },
        })
      }
    >
      <IconShipmentNew />
      <Trans id="article.actions.create-shipment">Create a shipment</Trans>
    </Button>
  );
};
